import { Role } from '@ringdna/common/src/types/roles'

export const createRoleOptions = (roleDefinitions: Role[]) => {
  return roleDefinitions?.map(role => ({ groupId: role.department, label: role.name, value: role.id }))
}
